import { enUS, fr } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const locales = { fr, en: enUS };

export const useDateFnsLocale = () => {
  const { i18n } = useTranslation();

  return locales[i18n.language as keyof typeof locales] || enUS;
};
